"use client"

import React, { useEffect, useState } from "react"

import { GlobalModalsRegistrar } from "compositions/modals"
import { Content, Footer } from "./components"

const PageLayout: React.CFC = props => {
  let { children } = props
  const [showFooter, setShowFooter] = useState(false)

  useEffect(() => {
    // Delay footer rendering to prevent layout shift on first load
    const timer = setTimeout(() => {
      setShowFooter(true)
    }, 100)

    return () => clearTimeout(timer)
  }, [])

  return (
    <>
      <Content>
        <div className="flex-1">{children}</div>
        {showFooter && <Footer />}
        <GlobalModalsRegistrar />
      </Content>
      <div id="modals" />
    </>
  )
}

export default PageLayout
